import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { Col, Row } from 'react-bootstrap'
import { GatsbyImage } from 'gatsby-plugin-image'
import { getShopifyImage } from 'gatsby-source-shopify'
import debounce from 'lodash.debounce'
import { StoreContext } from '../../../context/store-context'
import DeleteIcon from '../../../icons/delete'
import { formatPrice } from '../../../utils/format-price'
import { labelColumn, remove, variant } from '../LineItem/line-item.module.scss'
import { NumericInput } from '../NumericInput/NumericInput'
import { totals } from './mini-line-item.module.scss'

export function LineItem({ item, emptyCart = false }) {
  const { removeLineItem, checkout, updateLineItem, loading } =
    useContext(StoreContext)
  const [quantity, setQuantity] = useState(item.quantity)

  useEffect(() => {
    setQuantity(item.quantity)
  }, [item.quantity])

  const variantImage = {
    ...item.variant.image,
    originalSrc: item.variant.image.src,
  }
  const price = formatPrice(
    item.variant.priceV2.currencyCode,
    Number(item.variant.priceV2.amount),
  )

  const handleRemove = () => {
    let dataLayer = {
      event: 'view_item',
      ecommerce: {
        currency: 'USD',
        value: item.variant.price.amount,
        items: [
          {
            item_id: item.id,
            item_name: item.title,
            // item_category: product.productType,
            // item_list_id: mainCollection.shopifyId,
            // item_list_name: mainCollection.title,
            item_variant: item.variant.title,
            price: item.variant.price.amount,
          },
        ],
      },
    }

    // Check if window object is defined, then push ecommerce data to the data layer
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push(dataLayer)
    }

    removeLineItem(checkout.id, item.id)
  }

  const uli = debounce(
    (value) => updateLineItem(checkout.id, item.id, value),
    300,
  )
  // eslint-disable-next-line
  const debouncedUli = useCallback((value) => uli(value), [])

  const handleQuantityChange = (value) => {
    if (value !== '' && Number(value) < 1) {
      return
    }
    setQuantity(value)
    if (Number(value) >= 1) {
      debouncedUli(value)
    }
  }

  function doIncrement() {
    handleQuantityChange(Number(quantity || 0) + 1)
  }

  function doDecrement() {
    handleQuantityChange(Number(quantity || 0) - 1)
  }

  const image = useMemo(
    () =>
      getShopifyImage({
        image: variantImage,
        layout: 'constrained',
        crop: 'contain',
        width: 200,
        height: 80,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [variantImage.src],
  )

  return (
    <>
      <Row className={`mt-3`}>
        <Col className={labelColumn}>
          {image && (
            <GatsbyImage
              key={variantImage.src}
              image={image}
              alt={variantImage.altText ?? item.variant.title}
              width={100}
            />
          )}
        </Col>
        <Col className={labelColumn}>
          <h6>{item.title}</h6>
          {!emptyCart && (
            <div className={`mt-3 ${variant}`}>
              {item.variant.title === 'Default Title' ? '' : item.variant.title}
            </div>
          )}
        </Col>
        <Col className={totals}>
          {!emptyCart && (
            <NumericInput
              disabled={loading}
              value={quantity}
              aria-label='Quantity'
              onIncrement={doIncrement}
              onDecrement={doDecrement}
              onChange={(e) => handleQuantityChange(e.currentTarget.value)}
            />
          )}
        </Col>
      </Row>
      <Row>
        {emptyCart && (
          <Col className={labelColumn}>
            <div style={{ textAlign: 'right' }}>{price}</div>
          </Col>
        )}
        {!emptyCart && (
          <Col className={`mt-3 ${totals}`}>
            <div className={remove}>
              <button onClick={handleRemove}>
                <DeleteIcon /> Remove
              </button>
            </div>
          </Col>
        )}
      </Row>
    </>
  )
}
